import CountryManagementFiltersHttpRequest from './01_CountryManagementFilters.thunk';
import CMMonthRangeHttpRequest from './02_CMMonthRange.thunk';
import CountryRegionsData, {
  CRMSummaryData,
  RegionSummaryData,
} from './02_CountryRegionOverview/countryRegion.thunk';
import CountrySpecificRegionData from './02_CountryRegionOverview/countrySpecificRegion.thunk';
import cmEnrollmentRangeHttpRequest from './03_CMEnrollmentRange.thunk';
import countryEnrollmentDetailsHttpRequest from './03_CountryView/countryEnrollmentDetailsHttpRequest';
import countryRegionTrials from './03_CountryView/countryRegionTrials';
import SiteKeyPrincipalInvestigator from './03_CountryView/siteKeyPrincipalInvestigator.thunk';
import SiteMetricsHttpRequest from './03_CountryView/siteMetricsHttpRequest';
import sitesCountryRegionHttpRequest from './03_CountryView/sitesCountryRegionHttpRequest';
import TrialData from './03_CountryView/trialDataTable.thunk';
import TrialMetricsHttpRequest from './03_CountryView/trialMetricsHttpRequest';
import filterDetails from './03_CountryView/filterDetails';

export {
  CountryManagementFiltersHttpRequest,
  CountryRegionsData,
  CMMonthRangeHttpRequest,
  CRMSummaryData,
  cmEnrollmentRangeHttpRequest,
};

export const API_LIST = [
  CountryManagementFiltersHttpRequest,
  CMMonthRangeHttpRequest,
  CountryRegionsData,
  countryEnrollmentDetailsHttpRequest,
  countryRegionTrials,
  filterDetails,
  SiteKeyPrincipalInvestigator,
  SiteMetricsHttpRequest,
  sitesCountryRegionHttpRequest,
  TrialData,
  TrialMetricsHttpRequest,
  CountryRegionsData,
  CountrySpecificRegionData,
  RegionSummaryData,
  CRMSummaryData,
  cmEnrollmentRangeHttpRequest,
];
